import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Logo } from '../brand/Logo';
import './AuthLayout.css';

export interface AuthLayoutProps {
  title: string;
  subtitle?: string;
  /** Optional: a screen that is only a message has nothing to put here. */
  children?: ReactNode;
  footer?: ReactNode;
}

/** Shared frame for every signed-out account screen. */
export function AuthLayout({ title, subtitle, children, footer }: AuthLayoutProps) {
  return (
    <div className="sc-auth">
      <main className="sc-auth__panel">
        <Link to="/" className="sc-auth__brand" aria-label="Simple Coffee home">
          <Logo />
        </Link>

        <h1 className="sc-auth__title">{title}</h1>
        {subtitle && <p className="sc-auth__subtitle">{subtitle}</p>}

        {children}

        {footer && <div className="sc-auth__footer">{footer}</div>}
      </main>
    </div>
  );
}
